import { createAsyncThunk } from "@reduxjs/toolkit";

import { getErrorMessage } from "@fitness-app/utils";

import { type ActionParams, type AsyncThunkCreator } from "../../../index";
import { PRODUCT_CLIENT_REDUCER } from "../types";

type Response = {
  status: string;
};

export const migrateSubscriptionToManualPayments = createAsyncThunk<
  Response,
  ActionParams<{ subscriptionId: string; productId: string; clientId: string }, Response>,
  AsyncThunkCreator<string>
>(
  `${PRODUCT_CLIENT_REDUCER}/migrateSubscriptionToManualPayments`,
  async ({ payload, onSuccess, onFailure }, { rejectWithValue, extra: { productApi } }) => {
    try {
      const res = await productApi.post<Response>("/migrate-subscription-to-manual-payments", payload);
      onSuccess?.(res.data);

      return res.data;
    } catch (e) {
      onFailure?.();

      return rejectWithValue(getErrorMessage(e));
    }
  },
);
